const e = "uikit-root", n = () => {
  const t = document.getElementById(e), o = document.createElement("div");
  return o.setAttribute("id", e), t || document.body.appendChild(o);
};
export {
  e as PORTAL_ROOT_ID,
  n as getOrCreatePortalRoot
};
//# sourceMappingURL=portalRoot.js.map
